module.exports = __webpack_public_path__ + "static/media/sunflower.a1dce669.jpg";